import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { useQueryClient } from '@tanstack/react-query'
import { checkContractRequest } from 'store/modules/contract/actions'
import { setUnitSelected } from 'store/modules/unitSelected/actions'
import { StructureElement } from 'types/structureElement.type'

export const useChangeUnit = (): {
  changeUnit: (id: number) => void
} => {
  const queryClient = useQueryClient()
  const dispatch = useDispatch()
  const history = useHistory()

  const allUnits = useSelector(state => state.units.data) as StructureElement[]

  const getUnit = useCallback(
    (id: number) => allUnits.find(u => u.id_elemento === id),
    [allUnits]
  )

  const changeUnit = useCallback(
    (id: number) => {
      dispatch(setUnitSelected(getUnit(id)))
      dispatch(checkContractRequest())
      history.push('/')

      queryClient.cancelQueries()
      queryClient.clear()
    },
    [dispatch, getUnit, history, queryClient]
  )

  return { changeUnit }
}
